import { ListItemText, ListItem, List, Button, Fade, FormControl, FormControlLabel, Grid, Grow, IconButton, Input, InputAdornment, InputLabel, makeStyles, Radio, RadioGroup, Typography } from '@material-ui/core';
import { ListItemButton, Box } from '@mui/material';
import { AccountCircle, Lock, LockOpen, Visibility, VisibilityOff } from '@material-ui/icons';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AnimatedButton from '../../components/UI/AnimatedButton';
import RegexTextField from '../../components/UI/RegexTextField';
import { ROLES, STORAGE, SUPPLIER_TYPES } from '../../constants/GlobalConstants';
import { ROUTES } from '../../constants/RoutingConstants';
import { separations } from '../../constants/StyleConstants';
import { AppContext } from '../../contexts/AppContext';
import { LoginAPI } from '../../services/LoginAPI';
import BlockingPopUp from '../../components/BlockingPopUp';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg.jpg)`,
    backgroundSize: 'cover',
    // backgroundPosition: 'center',
  },
  loginCard: {
    display: 'flex',
    // width: 615,
    height: 409,
    borderRadius: 10,
    overflow: 'hidden',
    boxShadow: '0 0 30px 0 rgba(0,0,0,.5)',
  },
  splashImage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 245,
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg-color.png)`,
    backgroundSize: 'cover',
    color: 'white',
    padding: 10
  },
  imageTitle: {
    height: '80%',
    display: 'flex',
    alignItems: 'center'
  },
  imageAAIP: {
    height: '20%',
    display: 'flex',
    alignSelf: 'start'
  },
  aaipImage: {
      width: 55,
      height: 71,
      border: 0
  },
  loginForm: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    width: 370,
    padding: 20,
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow:'hidden'
  },
  loginField: {
    width: '100%',
  },
  loginManagmentOptions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  loginManagmentBtn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginBtn: {
    marginTop: '1em',
    borderRadius: 10,
  },
  fillBlankSpace: {
    height: '5em',
  },
  validationModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    borderRadius: '8px',
    padding: '35px',
    width: '35%'
  },
  validationForm:{
    display: 'flex',
    flexDirection: 'column'
  },
  validationCodeBtn: {
    marginTop: '1em',
    borderRadius: 10,
    width: '100%'
  },
  showPanel:{
    display:'flex'
  },
  hidePanel:{
    display:'none'
  },
  listItem:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  listText:{
    textAlign:'center'
  },
  presentationText:{
    marginTop: '10px',
    marginBottom: '10px',
    padding:'10px',
    borderBottom: '1px solid grey'
  },
  ...separations,
}));

const UserCUITInput = ({ fieldValue, setFieldValue, isSupplier, isLocalSupplier }) => {
  const classes = useStyles();
  const [value, setValue] = useState(fieldValue);
  const [focus, setFocus] = useState(false);
  const onlyNumbers = /[^0-9]/gi;

  const reg = /^(\\d+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})$/

  return (
    <div className={classes.loginField}>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item>
          <AccountCircle color={focus ? 'primary' : 'action'} />
        </Grid>
        <Grid item xs={10}>
          <RegexTextField
            //regex={isSupplier ? onlyNumbers : undefined}
            regex={reg}
            fullWidth
            id="input-with-icon-grid"
            label={isSupplier ? (isLocalSupplier ? 'CUIT/Email' : 'Código Proveedor') : 'Usuario'}
            value={value}
            onChange={event => setValue(event.target.value)}
            onBlur={() => setFieldValue(value)}
            onBlurCapture={() => setFocus(false)}
            onFocus={() => setFocus(true)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const PasswordInput = ({ fieldValue, setFieldValue }) => {
  const classes = useStyles();
  const [value, setValue] = useState(fieldValue);
  const [showPassword, setShowPassword] = useState(false);
  const [focus, setFocus] = useState(false);

  return (
    <div className={classes.loginField}>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item>
          <Lock color={focus ? 'primary' : 'action'} />
        </Grid>
        <Grid item xs={10}>
          <FormControl className={classes.loginField}>
            <InputLabel htmlFor="standard-adornment-password">Contraseña</InputLabel>
            <Input
              id="standard-adornment-password"
              type={showPassword ? 'text' : 'password'}
              value={value}
              onChange={event => setValue(event.target.value)}
              onBlur={() => setFieldValue(value)}
              onBlurCapture={() => setFocus(false)}
              onFocus={() => setFocus(true)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Muestra/Oculta Contraseña"
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={event => event.preventDefault()}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
};

const CounterButton = ({ awaitTime, children, onClick }) => { // Tiempo en segundos
  const classes = useStyles();
  const [reached, setReached] = useState(false);
  const [time, setTime] = useState(awaitTime);
  let interval;

  const handlerAction = () => {
    setTime(awaitTime);
    setReached(false);
    setTimer();
    onClick();
  };

  const setTimer = () => {
    clearInterval(interval);
    interval = setInterval(() => {
      setTime(prevTime => {
        if (prevTime === 1) {
          clearInterval(interval);
          setReached(true);
        }
        return prevTime - 1;
      });
    }, 1000);
  }

  useEffect(() => {
    setTimer();
    return () => clearInterval(interval);
  }, []);

  return (
    <Button
      disabled={!reached}
      className={classes.validationCodeBtn}
      onClick={handlerAction}
      variant="outlined" 
      color="primary" 
    >
      {children} 
      {time == 0? '' : ' en: ' + time}
    </Button>
  );
};

const ValidationModal = ({handleSendAuth,handleCancelAuth,handleNewToken}) => {
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [codeMFA, setCodeMFA] = useState('');
  const classes = useStyles();
  const onlyNumbers = /[^0-9]/gi;

  return (<div className={classes.validationModal}>
    <div>
      <Typography variant="subtitle1">Se ha enviado un codigo de verificacion a su mail</Typography>
      <RegexTextField
        regex={onlyNumbers}
        fullWidth
        value={codeMFA}
        onChange={event => setCodeMFA(event.target.value)}
        label="Por favor, ingrese el código recibido"
      />
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={6}>
          <AnimatedButton className={classes.validationCodeBtn} variant="contained" onClick={()=> handleSendAuth({codeMFA, setLoading, setDisable})} color="primary" loading={loading}>
            Aceptar
          </AnimatedButton>
        </Grid>
        <Grid item xs={6}>
          <Button className={classes.validationCodeBtn} variant="contained" onClick={handleCancelAuth} color="secondary" disabled={disable}>
            Cancelar
          </Button>
        </Grid>
      </Grid>
      <CounterButton onClick={()=>handleNewToken(setLoading, setDisable)} awaitTime={60}>
        Generar nuevo código
      </CounterButton>
    </div>
  </div>);
};

const SuppliersList = ({suppliers, onClick})=>{
  const classes = useStyles();
  return(
    <>
      <Typography className={classes.presentationText} component="div" align="center">
        Seleccione el proveedor con cual ingresar
      </Typography>
      <Box component="div" sx={{width:'98%', overflow: 'auto', padding:'0px'}}>
        <List>
          <ListItem className={classes.listItem}>
            {suppliers.map(({cuit, fullName}) => (
              <ListItemButton divider>
                <ListItemText primary={cuit + " - " + fullName} onClick={()=>onClick(cuit)} className={classes.listText}/>
              </ListItemButton>
            ))}
          </ListItem>
        </List>
      </Box>
    </>
  )
}

const Login = ({ isSupplier }) => {
  const classes = useStyles();
  const { showError, showWarning, showSuccess } = useContext(AppContext);
  const [blocking, setBlocking] = useState(false);
  const [password, setPassword] = useState('');
  const [user, setUser] = useState('');
  const [growsIn, setGrowsIn] = useState(false);
  const [fadeIn, setFadeIn] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selecting, setSelecting] = useState(false);
  const [suppliersData, setSuppliersData] = useState(null);
  const [groupType, setGroupType] = useState(SUPPLIER_TYPES.LOCAL);
  const history = useHistory();
  const hrefAAIP = "https://www.argentina.gob.ar/aaip/datospersonales/reclama/30693170881--RL-2021-116110401-APN-DNPDP#AAIP";
  const srcAAIP = "https://www.argentina.gob.ar/sites/default/files/aaip-isologo.png";

  /* INICIO FIX para issue con Chrome. Autocomplete de user y password no dispara onChange */
  useEffect(() => {
    setUser(document.getElementById('input-with-icon-grid').value);
    setPassword(document.getElementById('standard-adornment-password').value);
  }, [user, password]);
  /* FIN FIX para issue con Chrome. Autocomplete de user y password no dispara onChange */

  useEffect(() => {
    STORAGE.clear();
  }, []);

  const validate = () => {
    let errors = [];
    const errorMessages = [];

    if ((errors[0] = user.isBlank())) {
      errorMessages.push(`Debe completar el ${isSupplier ? 'CUIT' : 'Usuario'}`);

    //} else if ((errors[0] = isSupplier && groupType === SUPPLIER_TYPES.LOCAL && (/^[^37][0-9]*/gi).test(user))) {
    //} else if ((errors[0] = isSupplier && groupType === SUPPLIER_TYPES.LOCAL && !(/^(20|23|24|27|30|33|34)([0-9]{9})$/gi).test(user))) {
    //  errorMessages.push(`Debe ingresar un CUIT de Proveedor válido`); 
    
    } else if ((errors[0] = isSupplier && groupType === SUPPLIER_TYPES.LOCAL && !(/^(\d+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/).test(user))) {
      errorMessages.push(`Debe ingresar un CUIT de Proveedor válido`);  
    }

    if ((errors[1] = password.isBlank())) {
      errorMessages.push('Debe completar la contraseña');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const executeTransition = action => {
    setGrowsIn(false);
    setTimeout(() => {
      setFadeIn(false);
      setTimeout(() => action(), 250);
    }, 250);
  };

  const handleSendAuth = (params) => {
    params.setLoading(true);
    params.setDisable(true);
    const {codeMFA} = params; 
    const isExternal = groupType === SUPPLIER_TYPES.EXTERNAL ? 'E' : 'I';
    LoginAPI.validateMFACode(user, password, isSupplier, isExternal, codeMFA)
        .then(res => {
          if(Array.isArray(res)){
            setSuppliersData(res);
            setSelecting(true);
            setBlocking(false);
          }
          else {
            STORAGE.set(STORAGE.USER_INFO, res.user);
            STORAGE.set(STORAGE.TOKEN, { expiration: res.expiration, token: res.token });
            executeTransition(() => (res.user.role === ROLES.GENERIC ? history.push(ROUTES.CLAIM_MGMT) : history.push(ROUTES.HOME)));
          }
        })
        .catch(error => {
          const data = error.response?.data;
          params.setLoading(false);
          params.setDisable(false);
          if (error.response?.status === 400) {
            showError(data);
          } else if (!data) {
            showError('Error al realizar la validacion');
          } else {
            const errorMessages = data.errors ? Object.values(data.errors) : [data];
            showError('Error al realizar la validacion', errorMessages);
        }});
  }

  const handleNewToken = (params) => {
    LoginAPI.newMFACode(user)
        .then(res => {
          showSuccess(res)
        })
        .catch(error => {
          const data = error.response?.data;
          params.setDisable(false);
          params.setLoading(false);
          if (error.response?.status === 400) {
            showError(data);
          } else if (!data) {
            showError('Error al generar código');
          } else {
            const errorMessages = data.errors ? Object.values(data.errors) : [data];
            showError('Error al generar código', errorMessages);
        }});
  }

  const handleCancelAuth = () => {
    setLoading(!loading);
    setBlocking(!blocking);
  }

  const handleLogin = () => {
    if (validate()) {
      setLoading(true);
      const isExternal = groupType === SUPPLIER_TYPES.EXTERNAL ? 'E' : 'I';
      LoginAPI.login(user, password, isSupplier, isExternal)
        .then(res => {
          if(res.mailConfirmationRequired) setBlocking(res.mailConfirmationRequired);
          else if(Array.isArray(res)){
            setSuppliersData(res);
            setSelecting(true);
          }
          else {
            STORAGE.set(STORAGE.USER_INFO, res.user);
            STORAGE.set(STORAGE.TOKEN, { expiration: res.expiration, token: res.token });
            executeTransition(() => (res.user.role === ROLES.GENERIC ? history.push(ROUTES.CLAIM_MGMT) : history.push(ROUTES.HOME)));
          }
        })
        .catch(error => {
          const data = error.response?.data;
          const errorDataMessagesList = {
            'CUIT/Email incorrecto': 'Usuario o CUIT/Código Incorrecto',
            'Password incorrecto': 'Contraseña Incorrecta',
            'Proveedor no es de tipo local':'Proveedor no es de tipo local',
            'Proveedor no es de tipo extranjero':'Proveedor no es de tipo extranjero',
            'El usuario no posee proveedores asignados':'El usuario no posee proveedores asignados',
          }
          const dataErrorMessages = errorDataMessagesList[data];
          if (error.response?.status === 401) {
            showError(dataErrorMessages);
          }else if (error.response?.status === 404) {
            showError(dataErrorMessages);
          } else if (!data) {
            showError('Error al realizar login');
          } else {
            const errorMessages = data.errors ? Object.values(data.errors) : [data];
            showError('Error al realizar login', errorMessages);
          }

          setLoading(false);
        });
    }
  };

  const handleSignUp = () => {
    executeTransition(() => {
      history.push(ROUTES.LOGIN.SIGN_UP);
    });
  };

  const handleForgotPassword = () => {
    executeTransition(() => {
      history.push(ROUTES.LOGIN.RECOVERY);
    });
  };

  const SupplierLoginActions = () => {
    const classes = useStyles();

    return (
      <div className={classes.loginManagmentOptions}>
        <IconButton aria-label="createUser" onClick={handleSignUp}>
          <div className={classes.loginManagmentBtn}>
            <AssignmentIndOutlinedIcon />
            <Typography variant="caption" color="primary">
              Registrarse
            </Typography>
          </div>
        </IconButton>
        <IconButton aria-label="recoverPassword" onClick={handleForgotPassword}>
          <div className={classes.loginManagmentBtn}>
            <LockOpen />
            <Typography variant="caption" color="primary">
              Olvidó su clave
            </Typography>
          </div>
        </IconButton>
      </div>
    );
  };

  const handleSupplierLogin = (SupplierCuit) => {
    const isExternal = groupType === SUPPLIER_TYPES.EXTERNAL ? 'E' : 'I';
      LoginAPI.Supplierlogin(user, password, isSupplier, isExternal, SupplierCuit)
        .then(res => {
          STORAGE.set(STORAGE.USER_INFO, res.user);
          STORAGE.set(STORAGE.TOKEN, { expiration: res.expiration, token: res.token });
          executeTransition(() => (res.user.role === ROLES.GENERIC ? history.push(ROUTES.CLAIM_MGMT) : history.push(ROUTES.HOME)));
        })
        .catch(error => {
          const data = error.response?.data;
          const errorDataMessagesList = {
            'CUIT incorrecto': 'Usuario o CUIT/Código Incorrecto',
            'Password incorrecto': 'Contraseña Incorrecta',
            'Proveedor no es de tipo local':'Proveedor no es de tipo local',
            'Proveedor no es de tipo extranjero':'Proveedor no es de tipo extranjero'
          }
          const dataErrorMessages = errorDataMessagesList[data];
          if (error.response?.status === 401) {
            showError(dataErrorMessages);
          } else if (!data) {
            showError('Error al realizar login');
          } else {
            const errorMessages = data.errors ? Object.values(data.errors) : [data];
            showError('Error al realizar login', errorMessages);
          }

          setLoading(false);
        });
  }

  return (
    <Fade in={fadeIn} timeout={500} onEntered={() => setGrowsIn(true)}>
      <div className={classes.root}>
        <Grow in={growsIn}>
          <div className={classes.loginCard}>
            <div className={classes.splashImage}>
                <div className={classes.imageTitle}>
                  <Typography component="div" align="center" variant="h6">
                    Bienvenido al <br></br>Portal de Proveedores
                  </Typography>
                </div>
                { isSupplier && <div className={classes.imageAAIP}>
                    <a href={hrefAAIP} rel="noreferrer" target="_blank">
                      <img className={classes.aaipImage} src={srcAAIP} alt="AAIP RNBD" />
                    </a>
                  </div> }
            </div>
            <div className={classes.loginForm + ' ' + (!selecting ? classes.showPanel : classes.hidePanel)} >
              <img alt="" src={process.env.PUBLIC_URL + '/images/logo.png'} width="55%" />
              { isSupplier &&
                <RadioGroup className={classes.topSeparation} aria-label="supplierType" name="supplierType" 
                  value={groupType} onChange={e => setGroupType(e.target.value)}>
                  <FormControlLabel value={SUPPLIER_TYPES.LOCAL} control={<Radio color="primary" />} label={SUPPLIER_TYPES.LOCAL} />
                  <FormControlLabel value={SUPPLIER_TYPES.EXTERNAL} control={<Radio color="primary" />} label={SUPPLIER_TYPES.EXTERNAL} />
                </RadioGroup>
              }
              <UserCUITInput fieldValue={user} setFieldValue={setUser} isSupplier={isSupplier} isLocalSupplier={groupType === SUPPLIER_TYPES.LOCAL}/>
              <PasswordInput fieldValue={password} setFieldValue={setPassword} />
              <AnimatedButton className={classes.loginBtn} variant="contained" color="primary" onClick={handleLogin} loading={loading}>
                Ingresar
              </AnimatedButton>
              {isSupplier && <SupplierLoginActions />}
              {!isSupplier && <div className={classes.fillBlankSpace} />}
            </div>
            {blocking? <BlockingPopUp>
              <ValidationModal 
                handleSendAuth={handleSendAuth}
                handleNewToken={handleNewToken}
                handleCancelAuth={handleCancelAuth}/>
            </BlockingPopUp>: null}
            <div className={classes.loginForm + ' ' + (selecting ? classes.showPanel : classes.hidePanel)} >
              <img alt="" src={process.env.PUBLIC_URL + '/images/logo.png'} width="55%" />
              {suppliersData != null? <SuppliersList onClick={handleSupplierLogin} suppliers={suppliersData} />: null}
              <div className={classes.fillBlankSpace}/>
            </div>
          </div>
        </Grow>
      </div>
    </Fade>
  );
};

export default Login;
